import { useNetworkState } from 'react-use';

import { IIcon } from 'components/Pages/Admin/shared/ItinerariesItemLanding/LandingActions/types';
import { getNotifications } from 'components/Pages/GuestPortal/LandingLayout/functions';
import { Phone, ShareNetwork, FilePdf } from 'components/shared/Icon/phosphorIcons';
import { useLandingV2Context } from 'detailsv2/LandingV2/context';
import useMediaBreakpoints from 'hooks/useMediaBreakpoints';
import useProposalPathForMobileAppBuilder from 'hooks/useProposalPathForMobileAppBuilder';
import { showSnackbar } from 'hooks/useSnackbar';
import i18n from 'i18n';
import axiosApi from 'utils/axios';
import { copyTextToClipboard } from 'utils/common';
import { saveAsPDF } from 'utils/filesDownloaders/pdf';
import { ITINERARIES_ITEM_TYPE_TO_ROUTE_SEGMENT_MAP } from 'utils/itineraries/functions';

import noop from '../../../../../utils/noop';
import { IRightActionsProps } from './types';

export const useLandingData = ({ contactsModalHandler = noop }: Pick<IRightActionsProps, 'contactsModalHandler'>) => {
  const { data: proposal, isPrivate } = useLandingV2Context();
  const { isTabletOrMobile } = useMediaBreakpoints();
  const notifications = proposal.confirmed ? getNotifications(proposal.id) : [];
  const { online } = useNetworkState();
  const mobileApplicationLink = useProposalPathForMobileAppBuilder(proposal.id, proposal.type);
  const withActionButton = !isPrivate && !isTabletOrMobile && proposal?.actionButton?.active;

  const onSaveAsPdf = () => {
    //@ts-ignore
    return saveAsPDF({ item: proposal, itinerariesItemType: proposal.type, translate: true });
  };

  const onShare = () => {
    if (online) {
      //@ts-ignore
      axiosApi.post(`/${ITINERARIES_ITEM_TYPE_TO_ROUTE_SEGMENT_MAP[proposal.type]}/${proposal.id}/copy_link`);
    }

    copyTextToClipboard(window.location.href);
    //@ts-ignore
    showSnackbar({ text: i18n.t('proposal_content.link_copied') });
  };

  const getContacts = () => contactsModalHandler();

  const iconsConfig: IIcon[] = [
    {
      type: 'share',
      icon: <ShareNetwork data-tip="" data-for="share" />,
      onClick: onShare,
      hint: i18n.t('proposal_content.copy_link'),
      isDisabled: false,
    },
    {
      type: 'pdf',
      icon: <FilePdf data-tip="" data-for="pdf" />,
      onClick: onSaveAsPdf,
      hint: i18n.t('proposal_content.file.download_as_pdf'),
      isDisabled: false,
    },
    {
      type: 'phone',
      icon: <Phone data-tip="" data-for="phone" />,
      onClick: getContacts,
      hint: i18n.t('proposal_content.contact.travel_consultant'),
      isDisabled: false,
    },
  ];

  return {
    proposal,
    iconsConfig,
    notifications,
    mobileApplicationLink,
    withActionButton,
    actionButtonOptions: proposal.actionButton,
  };
};
